import { Box } from '@mui/material';
import { useRef } from 'react';

export function ResizeHandle({ onResize }: { onResize: Function }) {
  const isResizing = useRef(false);
  const startX = useRef(0);
  const startY = useRef(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    isResizing.current = true;
    startX.current = e.clientX;
    startY.current = e.clientY;
    document.body.style.cursor = 'nwse-resize';
    document.body.style.userSelect = 'none';
    document.body.style.pointerEvents = 'none';

    const handleMouseMove = (moveEvent: MouseEvent) => {
      if (isResizing.current) {
        const deltaX = moveEvent.clientX - startX.current;
        const deltaY = moveEvent.clientY - startY.current;
        onResize({ deltaX, deltaY });
      }
    };

    const handleMouseUp = () => {
      isResizing.current = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      document.body.style.pointerEvents = '';
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <Box
      data-testid="resize-handle"
      sx={{
        position: 'absolute',
        top: -6,
        left: -6,
        width: 30,
        height: 30,
        cursor: 'nwse-resize',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        gap: 0.4,
        transform: 'rotate(45deg)',
      }}
      onMouseDown={handleMouseDown}
    >
      <Box sx={{ width: 2, height: 10, bgcolor: 'grey.300', borderRadius: 1 }} />
      <Box sx={{ width: 2, height: 22, bgcolor: 'grey.300', borderRadius: 1 }} />
    </Box>
  );
}
